import { render, staticRenderFns } from "./enter_serial.vue?vue&type=template&id=280fa764&"
import script from "./enter_serial.vue?vue&type=script&lang=js&"
export * from "./enter_serial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports